import React, { ReactNode } from "react";
import { Outlet } from "react-router-dom";
import { useAppSelector } from "../redux/app/hooks";

interface LayoutProps {
  children: ReactNode[];
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [Sidebar, Header] = children;
  const { openSidebar } = useAppSelector((state) => state.modals);

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar */}
      <div
        className={`w-[50%] lg:w-[15%] bg-gray-800 text-white z-50 lg:block ${
          openSidebar ? "absolute top-0 lg:relative w-[70%]" : "hidden lg:block"
        }`}
      >
        {Sidebar}
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col lg:w-[85%] w-full">
        {/* Header */}
        {Header}
        <main className=" bg-gray-100 flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
